import {observer} from 'mobx-react';
import {Panel, FormLayout, ObjectSelect2} from 'shared/components';
import {t} from 'shared/core';

const Interviewers = observer(({uiState}) => {
  const {interviewSchedule, users, errors} = uiState;
  const {interviewers, eventHost} = interviewSchedule;

  return (
    <div>
      <Panel.Header title={t('recruiting.interview_schedules.edit.Interviewers')}/>
      <FormLayout>
        <ObjectSelect2
          value={interviewers}
          items={users}
          by='id'
          display='name'
          multiple
          searchable
          label='recruiting.interview_schedules.edit.Interviewers'
          placeholder='recruiting.interview_schedules.edit.Add an interviewer'
          onAdd={user => interviewSchedule.addInterviewer(user)}
          onRemove={user => interviewSchedule.removeInterviewer(user)}
          errorMessage={errors.interviewerIds}
        />
        <ObjectSelect2
          value={eventHost}
          items={users}
          by='id'
          display='name'
          allowClear
          searchable
          label='recruiting.interview_schedules.edit.Meeting Host'
          placeholder='recruiting.interview_schedules.edit.Select a meeting host'
          onChange={user => interviewSchedule.merge({eventHost: user})}
          errorMessage={errors.eventHostId}
        />
      </FormLayout>
    </div>
  );
});

export default Interviewers;
